// eslint-disable-next-line import/no-anonymous-default-export
export default (location = [], action) => {
  switch (action.type) {
    case "FETCH_ALL_INTANGIBLE_ASSETS":
      return action.payload;

    case "CREATE_INTANGIBLE_ASSET":
      return [...location, action.payload];

    default:
      return location;
  }
};
